import { render, staticRenderFns } from "./Symbol.vue?vue&type=template&id=5f584902&scoped=true&"
import script from "./Symbol.vue?vue&type=script&lang=js&"
export * from "./Symbol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f584902",
  null
  
)

export default component.exports